// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.add-airport-modal{z-index:var(--index-confirm-modal)}`, "",{"version":3,"sources":["webpack://./src/components/Modal/styles.scss"],"names":[],"mappings":"AAAA,yBACE,kCAAA","sourcesContent":[".modal.add-airport-modal {\r\n  z-index: var(--index-confirm-modal);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
